import React, {useState, useEffect} from "react";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import { fetchTenantReport } from "./ReportsCrud"
import { useLocation } from "react-router";
import MetabaseEmbedCard from "./MetabaseEmbedCard";

function ReportsPage(props) {

    const [report, setReport] = useState(null)
    const [isReportFound, setIsReportFound] = useState(false);

    const {accessToken} = useSelector(
        ({auth}) => ({
            accessToken: auth.authToken,
        }));

    const location = useLocation();
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    useEffect(() => {

        fetchTenantReport(accessToken, lastSegment).then(response => {
            const currReport = response.data.data
            
            if(currReport){
                setReport(currReport)
                setIsReportFound(true)
            }
      
          }).catch(error => console.log(error))
    }, [location, accessToken, lastSegment])

    return (
        <>
            { isReportFound && report ? 
                <MetabaseEmbedCard
                    reportConfig={report}
                    accessToken={accessToken}
                    isDashboard={false}
                    path={lastSegment}
                />
                :
                null
            }
            
        </>
       
    );
}

export default injectIntl(ReportsPage);
